import React from 'react';
import { Box, Button, Icon, MenuItem, Typography } from '@material-ui/core';
import { ConfigFieldControl, ConfigTextField, IconPicker } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteEvent } from '../../hooks/event/useSiteEvent';
import { useSiteContext } from '../../SiteContext';
import SiteEventConfigurator from '../events/SiteEventConfigurator';
import { SiteComponent } from '../SiteComponentPlugin';
export const SiteButtonBase = props => {
    const { buttonProps, siteButtonProps } = props;
    const { text, variant, size, color, startIcon, endIcon } = siteButtonProps || {};
    return (React.createElement(Button, Object.assign({ size: size, color: color || 'primary', variant: variant || 'contained', startIcon: startIcon && React.createElement(Icon, null, startIcon), endIcon: endIcon && React.createElement(Icon, null, endIcon) }, buttonProps), text || 'Button'));
};
export const SiteButton = props => {
    const component = useSubscribeComponentChanges(SiteButtonPlugin, props);
    const { editing, isHover, hoverProps } = useSiteContext();
    const { emit } = useSiteEvent(component);
    const classes = ['site-button'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteButtonPlugin }, props),
        React.createElement(SiteButtonBase, { siteButtonProps: component.props, buttonProps: Object.assign(Object.assign({}, hoverProps(component)), { className: classes.join(' '), onClick: event => {
                    if (!editing) {
                        event.stopPropagation();
                        emit('onClick');
                    }
                } }) })));
};
export const SiteButtonBaseConfigurator = props => {
    const { hideEvents, siteButtonProps } = props;
    const { component, update } = useConfigComponent(props.component);
    const basePath = props.basePath || 'props';
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Title', value: (siteButtonProps === null || siteButtonProps === void 0 ? void 0 : siteButtonProps.text) || '', onChange: event => {
                    update(`${basePath}.text`, event.target.value);
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { select: true, fullWidth: true, label: 'Variant', value: (siteButtonProps === null || siteButtonProps === void 0 ? void 0 : siteButtonProps.variant) || '', onChange: event => {
                    update(`${basePath}.variant`, event.target.value);
                } }, ['contained', 'outlined', 'text'].map(variant => (React.createElement(MenuItem, { key: variant, value: variant }, variant))))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { select: true, fullWidth: true, label: 'Size', value: (siteButtonProps === null || siteButtonProps === void 0 ? void 0 : siteButtonProps.size) || '', onChange: event => {
                    update(`${basePath}.size`, event.target.value);
                } }, ['large', 'medium', 'small'].map(size => (React.createElement(MenuItem, { key: size, value: size }, size))))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { select: true, fullWidth: true, label: 'Color', value: (siteButtonProps === null || siteButtonProps === void 0 ? void 0 : siteButtonProps.color) || '', onChange: event => {
                    update(`${basePath}.color`, event.target.value);
                } }, ['primary', 'secondary'].map(color => (React.createElement(MenuItem, { key: color, value: color }, color))))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(IconPicker, { value: (siteButtonProps === null || siteButtonProps === void 0 ? void 0 : siteButtonProps.startIcon) || '', onChange: icon => {
                    update(`${basePath}.startIcon`, icon);
                } }),
            "Start Icon"),
        React.createElement(ConfigFieldControl, null,
            React.createElement(IconPicker, { value: (siteButtonProps === null || siteButtonProps === void 0 ? void 0 : siteButtonProps.endIcon) || '', onChange: icon => {
                    update(`${basePath}.endIcon`, icon);
                } }),
            "End Icon"),
        !hideEvents && (React.createElement(React.Fragment, null,
            React.createElement(Box, { mt: 1 },
                React.createElement(Typography, { variant: 'overline' }, "Events")),
            React.createElement(SiteEventConfigurator, { eventTypes: ['onClick'], component: component })))));
};
export const SiteButtonConfigurator = props => {
    const { component, hideEvents } = props;
    return (React.createElement(SiteButtonBaseConfigurator, { component: component, siteButtonProps: component.props, hideEvents: hideEvents }));
};
export const SiteButtonPlugin = {
    name: 'Button',
    type: 'button',
    component: SiteButton,
    configurator: SiteButtonConfigurator,
    initConfig: component => {
        if (!component.props)
            component.props = {};
        component.props.color = 'primary';
        component.props.variant = 'contained';
        component.props.text = 'Button';
        return component;
    }
};
//# sourceMappingURL=SiteButtonPlugin.js.map